import { render, staticRenderFns } from "./ApprovalRemind.vue?vue&type=template&id=77b58447"
import script from "./ApprovalRemind.vue?vue&type=script&lang=js"
export * from "./ApprovalRemind.vue?vue&type=script&lang=js"
import style0 from "./ApprovalRemind.vue?vue&type=style&index=0&id=77b58447&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports